import { Article } from "@project/shared-types";
import { lazy } from "react";

interface Props {
  article: Article;
}

const EditorBlocksClient = lazy(() => import("./EditorBlocksClient"));

export default function EditorBlocks({ article }: Props) {
  return (

    <EditorBlocksClient article={article} />
  );
}